import { FetchParams, Middleware, ResponseContext } from '@deckee/api-app-main';
import { captureEventAsync } from '../event-capture';
import { get } from '../local-storage';
import { afterLogout } from './call-endpoint';

export class ApiClientMiddleware implements Middleware {
  // eslint-disable-next-line class-methods-use-this
  pre(context: ResponseContext): Promise<FetchParams | void> {
    return get('backendService', 'clientToken').then((clientToken) => {
      const headers: { [key: string]: any } = {
        ...(context.init.headers || {}),
      };

      if (clientToken) {
        headers['api-key'] = clientToken;
      }

      const newInit = {
        ...(context.init || {}),
        headers,
      };
      return Promise.resolve({ url: context.url, init: newInit });
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async post(context: ResponseContext): Promise<Response | void> {
    // Match the call-endpoint 401 logic
    if (context.response.status === 401) {
      afterLogout(); // clear client side auth details

      captureEventAsync({
        type: 'app: unauthenticated api call',
        payload: {
          source: 'api-client-middleware',
          url: context.url,
        },
      }).then(() => {
        if (!window.location.pathname.includes('login')) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          window.location = `/maps${window.location.search}${window.location.hash}`;
        }
      });
    }

    return Promise.resolve(context.response);
  }
}
